import React from "react";

import { useIntl } from "react-intl";

import chat_chats_icon from "../../../../../../assets/Chat/chat_chats_icon.svg";
import chat_direct_contacts from "../../../../../../assets/Chat/chat_direct_contacts_icon.svg";
import chat_bots_icon from "../../../../../../assets/Chat/chat_bots_icon.svg";

import "../../ChatStyle.less";
import { useSelector, DefaultRootState, useDispatch } from "react-redux";
import { setCurrentRoomsList } from "../../../../../../appRedux/actions/ChatSettings";

interface ChatTabsInterface {}

const ChatTabs: React.FC<ChatTabsInterface> = () => {
   const { currentRoomsListFolder } = useSelector((state: DefaultRootState) => state.chatSettings);

   const intl = useIntl();
   const dispatch = useDispatch();

   const checkActiveButton = (button: string): boolean => {
      return button === currentRoomsListFolder;
   };

   return (
      <div className="chat-tabs">
         <div
            onClick={() => dispatch(setCurrentRoomsList("Messages"))}
            className={`chat-tabs__item ${checkActiveButton("Messages") && "active"}`}
            title={intl.formatMessage({ id: "chat.allChats" })}
         >
            <img src={chat_chats_icon} />
         </div>
         <div
            onClick={() => dispatch(setCurrentRoomsList("Contacts"))}
            className={`chat-tabs__item ${checkActiveButton("Contacts") && "active"}`}
            title={intl.formatMessage({ id: "chat.directChats" })}
         >
            <img src={chat_direct_contacts} />
         </div>
         <div
            onClick={() => dispatch(setCurrentRoomsList("Bots"))}
            className={`chat-tabs__item ${checkActiveButton("Bots") && "active"}`}
            title={intl.formatMessage({ id: "chat.botChats" })}
         >
            <img src={chat_bots_icon} />
         </div>
      </div>
   );
};

export default ChatTabs;
